var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-link',{staticClass:"sidebar-menu-subitem fs12-400",class:{ 'is-active': _vm.isActive },attrs:{"to":_vm.item.href}},[_vm._v(" "+_vm._s(_vm.item.title)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }